import React from "react";

import { DialogContent, FormControl, MenuItem, Select } from "@material-ui/core";

import TabPanel from "../TabPanel";

/**
 * Tab "Fluxo Padrão" — fluxos de boas vindas e resposta padrão.
 * Compartilhada entre WhatsAppModal (nativo) e PluginConnectionModal.
 * Os Selects NÃO são Formik; estado/handlers e o dataset `webhooks` (flows) vêm por props.
 */
const FlowbuilderTab = ({
  tab,
  classes,
  webhooks,
  flowIdNotPhrase,
  handleChangeFlowIdNotPhrase,
  flowIdWelcome,
  handleChangeFlowIdWelcome,
}) => {
  return (
    <TabPanel className={classes.container} value={tab} name="flowbuilder">
      <DialogContent>
        <h3>Fluxo de boas vindas</h3>
        <p>
          Este fluxo é disparado apenas para novos contatos, pessoas que voce
          não possui em sua lista de contatos e que mandaram uma mensagem
        </p>
        <FormControl
          variant="outlined"
          margin="dense"
          className={classes.FormControl}
          fullWidth
        >
          <Select
            name="flowIdNotPhrase"
            value={flowIdNotPhrase || ""}
            onChange={handleChangeFlowIdNotPhrase}
            id="flowIdNotPhrase"
            variant="outlined"
            margin="dense"
            labelId="flowIdNotPhrase-selection-label"
          >
            <MenuItem value={null}>{"Desabilitado"}</MenuItem>
            {webhooks.map((webhook) => (
              <MenuItem key={webhook.id} value={webhook.id}>
                {webhook.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogContent>
        <h3>Fluxo de resposta padrão</h3>
        <p>
          Resposta Padrão é enviada com qualquer caractere diferente de uma
          palavra chave. ATENÇÃO! Será disparada se o atendimento ja estiver
          fechado.
        </p>
        <FormControl
          variant="outlined"
          margin="dense"
          className={classes.FormControl}
          fullWidth
        >
          <Select
            name="flowIdWelcome"
            value={flowIdWelcome || ""}
            onChange={handleChangeFlowIdWelcome}
            id="flowIdWelcome"
            variant="outlined"
            margin="dense"
            labelId="flowIdWelcome-selection-label"
          >
            <MenuItem value={null}>{"Desabilitado"}</MenuItem>
            {webhooks.map((webhook) => (
              <MenuItem key={webhook.id} value={webhook.id}>
                {webhook.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
    </TabPanel>
  );
};

export default FlowbuilderTab;
